<template>
  <div class="d-flex footer-container" :id="`footer-${footerKey}`">
    <div v-if="!hidePointFooter" class="question_footer">
      <div class="question_footer_points">
        <span 
          :style="interactionData && interactionAttemptShow === `Interactions-${interactionData.interaction_attempt_id}` ? 
          questionFooterPointsStyle(interactionData.points_earned, interactionData.points_available ) : 
          ''">{{interactionData ? interactionData.points_earned : '-'}}  / {{interactionData ? interactionData.points_available : '-'}} pts</span>
      </div>
      <div class="question_footer_radio">
        <el-radio-group v-if="interactionData && interactionData.points_available > 0" v-model="interactionData.points_earned" @change="saveGrade(interactionData.points_earned, interactionData.interaction_attempt_id, interactionData.explanation, null)">
          <el-radio-button  :label="0">0</el-radio-button>
          <el-radio-button v-for="i in interactionData.points_available" :label="i" :key="i">{{i}}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div
      v-if="(
        hasSchoolAccess
        && interactionType === 'free_response'
      )"
      class="footer-comment-wrapper"
    >
      <div
        v-if="(
          comment
          && !editMode
        )"
        class="d-flex"
      >
        <div class="comment-box ma-3">
          <p class="font-weight-bold">Feedback from instructor:</p>
          <div v-dompurify-html="comment"></div>
        </div>
        <div class="button-box ma-3">
          <v-btn
            @click="editFeedback()"
            :disabled="!loaded"
            color="primary"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn
            @click="removeFeedback()"
            :disabled="!loaded"
            color="primary"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </div>
      </div>
      <div v-if="renderTinyMCEComponent">
        <TinyMCE
          aria-label="Instructor feedback form"
          :apiEnabled="true"
          :bulb-id="bulbId"
          :footerKey="footerKey"
          :inline="false"
          :interaction="interactionData"
          :initial-text="comment ? comment : ''"
          mode="feedback"
          :placeholder="'Leave feedback here'"
          :sectionId="sectionId"
          service="legacy-dash"
          :teacher="instructorData"
          :tinymceKey="interactionData.interaction_attempt_id"
          :token="instructorData.token"
          :updateCommentData="updateCommentData"
        />
      </div>
    </div>
  </div>
</template>
<script>

import { 
  mapActions,
  mapGetters,
} from 'vuex';

export default {
  name: 'InstructorQuestionFooter',
  data: () => ({
    comment: null,
    editMode: false, 
    commentLoaded: false,
    loaded: false,
  }),
  props: {
    bulbId: {
      type: Number,
    },
    interactionData: Object,
    interactionAttemptShow: String,
    saveGrade: Function,
    interactionType: String,
    show: Boolean,
    footerKey: Number,
    hidePointFooter: Boolean,
    sectionId: Number,
  },
  methods: {
    ...mapActions('instructors', [
      'getCommentData',
      'removeCommentData',
    ]),
    editFeedback() {
      this.editMode = true;
    },
    async loadComment() {
      const commentData = await this.getCommentData({
        interactionAttemptId: this.interactionData.interaction_attempt_id,
        sectionId: this.sectionId,
      });
      this.comment = commentData.data.comment;
      this.commentLoaded = true;
      this.loaded = true;
    },
    questionFooterPointsStyle(pointsEarned, pointsAvailable) {
      if(pointsAvailable == 0) {
        return {
          'color': '#858585',
        }
      } else if(pointsEarned === null){
        return {
          'color': '#fbbc04',
        }
      } else if(pointsEarned == 0){
        return {
          'color': '#ea4335'
        }
      } else {
        return {
          'color': '#34a853'
        }
      }
    },
    async removeFeedback() {
      this.loaded = false;
      await this.removeCommentData({ 
        interactionAttemptId: this.interactionData.interaction_attempt_id, 
        teacherId: this.instructorData.id, 
        sectionId: this.sectionId,
      });
      this.comment = null;
      this.loaded = true;
    },
    updateCommentData(comment) {
      this.comment = comment;
      this.editMode = false;
    }
  },
  computed: {
    ...mapGetters([
      'instructorData',
      'school',
    ]),
    hasSchoolAccess() {
      return !!this.school.id;
    },
    renderTinyMCEComponent() {
      // TODO TAM clean: quite a difficult conditional to follow... maybe we can make it less complex?
      return (
        (
          (
            (
              this.comment
              && this.editMode
            ) || !this.comment
          )
          && this.commentLoaded
          && this.loaded
        ) && (
          this.interactionType === 'free_response'
          && (
            this.interactionData
            && this.interactionAttemptShow
            && this.interactionAttemptShow.includes(this?.interactionData?.interaction_attempt_id)
          )
        )
      );
    },
  },
  watch: {
    interactionAttemptShow(val) {
      if (
        this.interactionData
        && val.includes(this.interactionData.interaction_attempt_id)
      ) {
        this.loadComment();
      }
    }
  },
};

</script>
<style type="scss" scoped>
  .button-box {
    width: 20%;
    display: flex;
    flex-direction: column;
  }
  .comment-box {
    width: 80%;
    height: 175px;
    padding: 10px;
    background-color: #E5E5E5;
    overflow-y: scroll;
  }
  .comment-box p {
    color: black;
  }
  .footer-container {
    flex-direction: column;
  }
</style>